/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBoxSettings = (props: Props) => (
  <Icon viewBox="0 0 25 24" {...props}>
    <g fill="none">
      <path
        d="M11.97 2.152a1 1 0 0 1 1.06 0l8 5A1 1 0 0 1 21.5 8v5.341a5.99 5.99 0 0 0-2-.341V9.804l-6 3.75v5.642l.003-.002c.023.735.179 1.436.443 2.081l-.916.573a1 1 0 0 1-1.06 0l-8-5A1 1 0 0 1 3.5 16V8a1 1 0 0 1 .47-.848zM5.5 9.804v5.642l6 3.75v-5.642zm7 2.017L18.613 8 12.5 4.18 6.387 8zm6 2.679v1.145c-.233.07-.455.162-.665.276l-.81-.81-1.414 1.414.81.81a3.44 3.44 0 0 0-.276.665H15v2h1.145c.07.233.162.455.276.665l-.81.81 1.414 1.414.81-.81c.21.114.432.207.665.276V23.5h2v-1.145c.233-.07.455-.162.665-.276l.81.81 1.414-1.414-.81-.81a3.44 3.44 0 0 0 .276-.665H24v-2h-1.145a3.481 3.481 0 0 0-.276-.665l.81-.81-1.414-1.414-.81.81a3.481 3.481 0 0 0-.665-.276V14.5zm1 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBoxSettings as BoxSettings };
